module.exports = __webpack_public_path__ + "img/clipboard-user.eb51a28d.svg";